import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getStore } from "./store";

import "./assets/css/style.css";
import "./assets/css/dark-style.css";
import "./assets/css/transparent-style.css";
import "./assets/css/skin-modes.css";
import "./assets/css/icons.css";

import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Index";
import CompanyList from "./components/Company/List";
import CompanyForm from "./components/Company/Form";
import VesselTypeList from "./components/VesselType/List";
import VesselTypeForm from "./components/VesselType/Form";
import VesselList from "./components/Vessel/List";
import VesselForm from "./components/Vessel/Form";
import ExperienceList from "./components/Experience/List";
import ExperienceForm from "./components/Experience/Form";
import RankList from "./components/Rank/List";
import RankForm from "./components/Rank/Form";
import GradeList from "./components/Grade/List";
import GradeForm from "./components/Grade/Form";
import PortList from "./components/Port/List";
import PortForm from "./components/Port/Form";
import PortagentList from "./components/Portagent/List";
import PortagentForm from "./components/Portagent/Form";
import HospitalList from "./components/Hospital/List";
import HospitalForm from "./components/Hospital/Form";
import DocumenttypeList from "./components/Documenttype/List";
import DocumenttypeForm from "./components/Documenttype/Form";
import VendorList from "./components/Vendor/List";
import VendorForm from "./components/Vendor/Form";
import BranchList from "./components/Branch/List";
import BranchForm from "./components/Branch/Form";
import CandidateList from "./components/Candidate/List";
import CandidateForm from "./components/Candidate/Form";
import CandidateView from "./components/Candidate/View";
import SearchList from "./components/Candidate/Search";
import RoleList from "./components/Role/List";
import RoleForm from "./components/Role/Form";
import POVendorList from "./components/POVendor/List";
import POVendorForm from "./components/POVendor/Form";
import Reports from "./components/Reports/List";
import PurchaseOrderList from "./components/PurchaseOrder/List";
import PurchaseOrderForm from "./components/PurchaseOrder/Form";
import PortagebillList from "./components/Portagebill/List";
import OfficedocumentList from "./components/Officedocument/List";
import OfficedocumentForm from "./components/Officedocument/Form";

import UsersList from "./components/Users/List";
import UsersForm from "./components/Users/Form";

import Evaluation from "./components/Candidate/Evaluation";
import Application from "./components/Candidate/Application";
import VesselPositionList from "./components/VesselPosition/List";
import VesselPositionForm from "./components/VesselPosition/Form";
import CrewPlannerList from "./components/CrewPlanner/List";
import CrewPlannerForm from "./components/CrewPlanner/Form";

import Logout from "./components/Helpers/Logout";
import Refpage from "./components/Layout/Refpage";
import Page404 from "./Page404";

// HRMS module
import DesignationList from "./components/Designation/List";
import DesignationForm from "./components/Designation/Form";
import DepartmentList from "./components/Department/List";
import DepartmentForm from "./components/Department/Form";
import SkillList from "./components/Skill/List";
import SkillForm from "./components/Skill/Form";
import LanguageList from "./components/Language/List";
import LanguageForm from "./components/Language/Form";
import IndustryList from "./components/Industry/List";
import IndustryForm from "./components/Industry/Form";
import StaffcategoryList from "./components/Staffcategory/List";
import StaffcategoryForm from "./components/Staffcategory/Form";
import ModeofentryList from "./components/Modeofentry/List";
import ModeofentryForm from "./components/Modeofentry/Form";
import IdentityList from "./components/Identity/List";
import IdentityForm from "./components/Identity/Form";
import CityList from "./components/City/List";
import CityForm from "./components/City/Form";
import DoctypeList from "./components/Doctype/List";
import DoctypeForm from "./components/Doctype/Form";
import EmpBranchList from "./components/EmpBranch/List";
import EmpBranchForm from "./components/EmpBranch/Form";
import EmpCompanyList from "./components/EmpCompany/List";
import EmpCompanyForm from "./components/EmpCompany/Form";
import EmployeeList from "./components/Employee/List";
import EmployeeForm from "./components/Employee/Form";
import EmployeeView from "./components/Employee/View";

const store = getStore();
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <Router>
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar={false} newestOnTop={true} closeOnClick pauseOnHover />
      <Switch>
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/owner" component={CompanyList} />
        <Route exact path="/owner/add" component={CompanyForm} />
        <Route exact path="/owner/edit" component={CompanyForm} />
        <Route exact path="/vesseltype" component={VesselTypeList} />
        <Route exact path="/vesseltype/add" component={VesselTypeForm} />
        <Route exact path="/vesseltype/edit" component={VesselTypeForm} />
        <Route exact path="/vessel" component={VesselList} />
        <Route exact path="/vessel/add" component={VesselForm} />
        <Route exact path="/vessel/edit" component={VesselForm} />
        <Route exact path="/experience" component={ExperienceList} />
        <Route exact path="/experience/add" component={ExperienceForm} />
        <Route exact path="/experience/edit" component={ExperienceForm} />
        <Route exact path="/rank" component={RankList} />
        <Route exact path="/rank/add" component={RankForm} />
        <Route exact path="/rank/edit" component={RankForm} />
        <Route exact path="/grade" component={GradeList} />
        <Route exact path="/grade/add" component={GradeForm} />
        <Route exact path="/grade/edit" component={GradeForm} />
        <Route exact path="/port" component={PortList} />
        <Route exact path="/port/add" component={PortForm} />
        <Route exact path="/port/edit" component={PortForm} />
        <Route exact path="/portagent" component={PortagentList} />
        <Route exact path="/portagent/add" component={PortagentForm} />
        <Route exact path="/portagent/edit" component={PortagentForm} />
        <Route exact path="/hospital" component={HospitalList} />
        <Route exact path="/hospital/add" component={HospitalForm} />
        <Route exact path="/hospital/edit" component={HospitalForm} />
        <Route exact path="/documenttype" component={DocumenttypeList} />
        <Route exact path="/documenttype/add" component={DocumenttypeForm} />
        <Route exact path="/documenttype/edit" component={DocumenttypeForm} />
        <Route exact path="/vendor" component={VendorList} />
        <Route exact path="/vendor/add" component={VendorForm} />
        <Route exact path="/vendor/edit" component={VendorForm} />
        <Route exact path="/branch" component={BranchList} />
        <Route exact path="/branch/add" component={BranchForm} />
        <Route exact path="/branch/edit" component={BranchForm} />
        <Route exact path="/candidate" component={CandidateList} />
        <Route exact path="/candidate/add" component={CandidateForm} />
        <Route exact path="/candidate/edit" component={CandidateForm} />
        <Route exact path="/candidate/view/:editID/:tabType" component={CandidateView} />
        <Route exact path="/candidate/view/:editID" component={CandidateView} />
        <Route exact path="/candidate/evaluation/:candidateID" component={Evaluation} />
        <Route exact path="/candidate/application/:candidateID" component={Application} />
        <Route exact path="/candidate/application/:candidateID/view" component={Application} />

        <Route exact path="/purchaseorder" component={PurchaseOrderList} />
        <Route exact path="/purchaseorder/add" component={PurchaseOrderForm} />
        <Route exact path="/purchaseorder/edit" component={PurchaseOrderForm} />
        <Route exact path="/portagebill" component={PortagebillList} />
        <Route exact path="/officedocument" component={OfficedocumentList} />
        <Route exact path="/officedocument/add" component={OfficedocumentForm} />
        <Route exact path="/officedocument/edit" component={OfficedocumentForm} />
        <Route exact path="/search" component={SearchList} />
        <Route exact path="/reports" component={Reports} />
        <Route exact path="/role" component={RoleList} />
        <Route exact path="/role/add" component={RoleForm} />
        <Route exact path="/role/edit" component={RoleForm} />
        <Route exact path="/povendor" component={POVendorList} />
        <Route exact path="/povendor/add" component={POVendorForm} />
        <Route exact path="/povendor/edit" component={POVendorForm} />
        <Route exact path="/users" component={UsersList} />
        <Route exact path="/users/add" component={UsersForm} />
        <Route exact path="/users/edit" component={UsersForm} />
        <Route exact path="/vesselposition" component={VesselPositionList} />
        <Route exact path="/vesselposition/add" component={VesselPositionForm} />
        <Route exact path="/vesselposition/edit" component={VesselPositionForm} />
        <Route exact path="/crewplanner" component={CrewPlannerList} />
        <Route exact path="/crewplanner/add" component={CrewPlannerForm} />
        <Route exact path="/crewplanner/edit" component={CrewPlannerForm} />
        {/* HRMS module */}
        <Route exact path="/hrms/designation" component={DesignationList} />
        <Route exact path="/hrms/designation/add" component={DesignationForm} />
        <Route exact path="/hrms/designation/edit/:editID" component={DesignationForm} />
        <Route exact path="/hrms/department" component={DepartmentList} />
        <Route exact path="/hrms/department/add" component={DepartmentForm} />
        <Route exact path="/hrms/department/edit/:editID" component={DepartmentForm} />
        <Route exact path="/hrms/skill" component={SkillList} />
        <Route exact path="/hrms/skill/add" component={SkillForm} />
        <Route exact path="/hrms/skill/edit/:editID" component={SkillForm} />
        <Route exact path="/hrms/language" component={LanguageList} />
        <Route exact path="/hrms/language/add" component={LanguageForm} />
        <Route exact path="/hrms/language/edit/:editID" component={LanguageForm} />
        <Route exact path="/hrms/industry" component={IndustryList} />
        <Route exact path="/hrms/industry/add" component={IndustryForm} />
        <Route exact path="/hrms/industry/edit/:editID" component={IndustryForm} />
        <Route exact path="/hrms/staffcategory" component={StaffcategoryList} />
        <Route exact path="/hrms/staffcategory/add" component={StaffcategoryForm} />
        <Route exact path="/hrms/staffcategory/edit/:editID" component={StaffcategoryForm} />
        <Route exact path="/hrms/modeofentry" component={ModeofentryList} />
        <Route exact path="/hrms/modeofentry/add" component={ModeofentryForm} />
        <Route exact path="/hrms/modeofentry/edit/:editID" component={ModeofentryForm} />
        <Route exact path="/hrms/identity" component={IdentityList} />
        <Route exact path="/hrms/identity/add" component={IdentityForm} />
        <Route exact path="/hrms/identity/edit/:editID" component={IdentityForm} />
        <Route exact path="/hrms/city" component={CityList} />
        <Route exact path="/hrms/city/add" component={CityForm} />
        <Route exact path="/hrms/city/edit/:editID" component={CityForm} />
        <Route exact path="/hrms/doctype" component={DoctypeList} />
        <Route exact path="/hrms/doctype/add" component={DoctypeForm} />
        <Route exact path="/hrms/doctype/edit/:editID" component={DoctypeForm} />
        <Route exact path="/hrms/branch" component={EmpBranchList} />
        <Route exact path="/hrms/branch/add" component={EmpBranchForm} />
        <Route exact path="/hrms/branch/edit/:editID" component={EmpBranchForm} />
        <Route exact path="/hrms/company" component={EmpCompanyList} />
        <Route exact path="/hrms/company/add" component={EmpCompanyForm} />
        <Route exact path="/hrms/company/edit/:editID" component={EmpCompanyForm} />
        <Route exact path="/hrms/employee" component={EmployeeList} />
        <Route exact path="/hrms/employee/add" component={EmployeeForm} />
        <Route exact path="/hrms/employee/edit/:editID" component={EmployeeForm} />
        <Route exact path="/hrms/employee/view/:editID" component={EmployeeView} />

        <Route path={"/refpage/:slugtext"} component={Refpage} />
        <Route path={"/logout/:LoginType"} component={Logout} />
        <Route path={"/logout"} component={Logout} />
        <Route exact path="/" component={Login} />
        <Route component={Page404} />
      </Switch>
    </Router>
  </Provider>,
);
